import { Column, CreateDateColumn, Entity, JoinColumn, ManyToOne, PrimaryGeneratedColumn, UpdateDateColumn, VersionColumn } from "typeorm";
import { Operations } from "../operations/operations.entity";

@Entity('qa_qc_operations')
export class QaQcOperations {
    @PrimaryGeneratedColumn("increment", { name: 'qa_qc_op_id' })
    qaQcTestId: number;

    @Column("varchar", {
        nullable: false,
        length: 100,
        name: "test_code"
    })
    testCode: string;

    @Column("varchar", {
        nullable: true,
        length: 100,
        name: "test_name"
    })
    testName: string;

    // @Column("varchar", {
    //     nullable: true,
    //     length: 100,
    //     name: "test_description"
    // })
    // testDescription: string;

    @Column("boolean", {
        nullable: false,
        default: true,
        name: "is_active"
    })
    isActive: boolean;

    @CreateDateColumn({
        name: "created_at",
        type: "datetime"
    })
    createdAt: Date;

    @Column("varchar", {
        nullable: false,
        name: "created_user",
        length: 50
    })
    createdUser: string | null;


    @UpdateDateColumn({
        name: "updated_at",
        type: 'datetime'
    })
    updatedAt: Date;

    @Column("varchar", {
        nullable: true,
        name: "updated_user",
        length: 50
    })
    updatedUser: string | null;

    @VersionColumn({
        default: 1,
        name: "version_flag"
    })

    versionFlag: number;


    @ManyToOne(type => Operations, operations => operations.qaQcInfo, { nullable: false})
    @JoinColumn({ name: "operation_id" })
    operationInfo: Operations;
}